import {
    type DealerWithPermissionsFragmentFragment,
    type ModuleInDealerSpecsFragment,
} from '../../../../api/fragments';
import { ModuleType } from '../../../../api/types';
import DealerAssignmentAppointmentForm from './DealerAssignmentAppointmentForm';
import DealerAssignmentConfiguratorForm from './DealerAssignmentConfiguratorForm';
import DealerAssignmentEventForm from './DealerAssignmentEventForm';
import DealerAssignmentFinderForm from './DealerAssignmentFinderForm';
import DealerAssignmentGiftVoucherForm from './DealerAssignmentGiftVoucherForm';
import DealerAssignmentMobilityForm from './DealerAssignmentMobilityForm';
import DealerAssignmentStandardForm from './DealerAssignmentStandardForm';

export type DealerAssignFormProps = {
    module: ModuleInDealerSpecsFragment;
    dealer: DealerWithPermissionsFragmentFragment;
};

const DealerAssignmentForm = ({ module, dealer }: DealerAssignFormProps) => {
    switch (module.__typename) {
        case ModuleType.StandardApplicationModule:
            return <DealerAssignmentStandardForm dealer={dealer} module={module} />;

        case ModuleType.ConfiguratorModule:
            return <DealerAssignmentConfiguratorForm dealer={dealer} module={module} />;

        case ModuleType.EventApplicationModule:
            return <DealerAssignmentEventForm dealer={dealer} module={module} />;

        case ModuleType.FinderApplicationPublicModule:
        case ModuleType.FinderApplicationPrivateModule:
            return <DealerAssignmentFinderForm dealer={dealer} module={module} />;

        case ModuleType.MobilityModule:
            return <DealerAssignmentMobilityForm dealer={dealer} module={module} />;

        case ModuleType.AppointmentModule:
            return <DealerAssignmentAppointmentForm dealer={dealer} module={module} />;

        case ModuleType.GiftVoucherModule:
            return <DealerAssignmentGiftVoucherForm dealer={dealer} module={module} />;

        default:
            return null;
    }
};

export default DealerAssignmentForm;
